import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { mq } = theme.custom;
    return {
        tags: { width: 260, [mq.md]: { width: 230 }, [mq.sm]: { width: 'auto', gridColumn: '1 / -1' } },
    };
});
